module.exports = __webpack_public_path__ + "img/preloader.96d8ec11.svg";